export default __webpack_public_path__ + "static/media/World type image.6a44a898.svg";